export enum NavAction {
    Settings = 'settings',
    Help = 'help',
    Search = 'search',
    CopyDetails = 'copyDetails',
    Logout = 'logout',
    RequestStatus = 'requestStatus',
    Notification = 'notification'
}
